import { AddPollInput, UpdatePollInput } from "@/gen/graphql";

export function isUpdatePollOption(
    option: AddPollInput["options"][number] | UpdatePollInput["options"][number]
): option is UpdatePollInput["options"][number] {
    return "id" in option;
}
